// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_courseCard__3l2wY {
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  background: white;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.styles_courseCard__3l2wY.styles_expanded__Jdt5V {
  cursor: default;
}
.styles_courseCard__3l2wY.styles_deleted__RULEb {
  opacity: 0.6;
  position: relative;
}

.styles_crossoutOverlay__Ccf72 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  opacity: 0.8;
  pointer-events: none;
  z-index: 10;
  transition: all 0.3s ease;
}

.styles_crossoutOverlayExpanded__oHF-R {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  opacity: 0.8;
  pointer-events: none;
  z-index: 10;
  transition: all 0.3s ease;
}

.styles_cardContent__X01qM {
  position: relative;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.styles_calendarIcon__048Lo {
  width: 30px;
  height: 30px;
  object-fit: contain;
  opacity: 0.9;
  flex-shrink: 0;
  position: relative;
  bottom: 3px;
}
@media (min-width: 640px) {
  .styles_calendarIcon__048Lo {
    width: 30px;
    height: 30px;
  }
}

.styles_courseHeaderCollapsed__Sr\\+9H {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding-right: 40px;
}

.styles_courseHeader__u8GTj {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.styles_colorDot__FXKmb {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  flex-shrink: 0;
}

.styles_colorPickerContainer__wwaOG {
  position: relative;
}

.styles_colorPickerContainerExpanded__vNXNd {
  position: relative;
  top: 3px;
}

.styles_colorPickerWrapper__t3rh3 {
  position: absolute;
  top: -5px;
  right: 0px;
  z-index: 2;
}

.styles_colorButton__x9YEN {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}
.styles_colorButton__x9YEN:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.styles_colorButton__x9YEN:active {
  transform: scale(0.95);
}

.styles_colorButtonExpanded__I50km {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}
.styles_colorButtonExpanded__I50km:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.styles_colorButtonExpanded__I50km:active {
  transform: scale(0.95);
}

.styles_colorButtonTop__\\+VclG {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.styles_colorButtonTop__\\+VclG:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.styles_colorPaletteTop__clcMc {
  position: absolute;
  top: 0px;
  right: 30px;
  background: white;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
  z-index: 100;
  min-width: 30px;
}

.styles_colorPalette__WIzIe {
  position: absolute;
  top: 40px;
  left: 0;
  background: white;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  z-index: 100;
  min-width: 100px;
}

.styles_colorPaletteExpanded__FvZ7p {
  position: absolute;
  top: 40px;
  left: 0;
  background: white;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  z-index: 100;
  min-width: 100px;
}

.styles_colorOption__m5\\+k9 {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.styles_colorOption__m5\\+k9:hover {
  transform: scale(1.1);
  border-color: rgba(0, 0, 0, 0.2);
}
.styles_colorOption__m5\\+k9 svg {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
}

.styles_colorOptionExpanded__5d72I {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.styles_colorOptionExpanded__5d72I:hover {
  transform: scale(1.1);
  border-color: rgba(0, 0, 0, 0.2);
}
.styles_colorOptionExpanded__5d72I svg {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
}

.styles_courseTitleContainer__3qhdv {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.styles_editIcon__R1RFw {
  width: 20px;
  height: 20px;
  opacity: 0.6;
  cursor: pointer;
  transition: opacity 0.2s;
}
.styles_editIcon__R1RFw:hover {
  opacity: 1;
}

.styles_courseName__ex33l {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0;
}

.styles_courseHeaderCollapsed__Sr\\+9H .styles_courseName__ex33l.styles_updating__1kgiR {
  background: linear-gradient(90deg, var(--course-color, #039be5) 0%, var(--course-color, #039be5) 40%, rgba(255, 255, 255, 0.3) 50%, var(--course-color, #039be5) 60%, var(--course-color, #039be5) 100%);
  background-size: 200% 100%;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: styles_shimmer__dyLg3 3s ease-in-out infinite;
}

@keyframes styles_shimmer__dyLg3 {
  0% {
    background-position: -100% 0;
  }
  50% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
.styles_divider__ZTJbY {
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
  margin: 12px 0;
}

.styles_courseNameInput__Kptze {
  flex: 1 1;
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  padding: 4px 8px;
  outline: none;
}
.styles_courseNameInput__Kptze:focus {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 2px rgba(var(--color-primary-rgb), 0.2);
}

.styles_sectionDisplay__wpoG8 {
  font-size: 14px;
  color: var(--color-text-secondary);
  padding: 8px 0;
  margin-bottom: 12px;
}

.styles_sectionSelector__w498W {
  margin-bottom: 0px;
}

.styles_sectionRow__rakkC {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  align-items: center;
}

.styles_cardPreview__aS3-v {
  display: none;
}

.styles_infoRow__C5PFI {
  display: flex;
  gap: 40px;
  margin-bottom: 20px;
  flex-direction: column;
}
@media (min-width: 640px) {
  .styles_infoRow__C5PFI {
    flex-direction: row;
    gap: 40px;
  }
}

.styles_leftColumn__f7ARp {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.styles_rightColumn__ZlUjV {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.styles_previewInfo__x0fWp {
  display: flex;
  align-items: center;
  gap: 8px;
}

.styles_scheduleIcon__K0Qxt {
  font-size: 14px;
  opacity: 0.7;
}

.styles_scheduleText__8eD3q {
  font-size: 16px;
  color: var(--color-text-primary);
}

.styles_smartDescription__ZKu4p {
  padding: 12px 1px;
  min-height: 48px;
  display: flex;
  align-items: center;
}

.styles_descriptionLoading__GNWxs {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.styles_loadingText__PmO8y {
  color: #6b7280;
  font-size: 13px;
  font-style: italic;
  animation: styles_fadeInOut__kRGql 2s ease-in-out infinite;
}
.styles_expandedDescription__yboe0 .styles_loadingText__PmO8y {
  font-size: 14px;
}

@keyframes styles_fadeInOut__kRGql {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
.styles_oceanLogoWrapper__ERtTx {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.styles_oceanLogoSpinner__\\+LFpY {
  width: 100%;
  height: 100%;
  animation: styles_oceanWave__l6tip 1.5s ease-in-out infinite;
  filter: brightness(0) saturate(100%) invert(54%) sepia(85%) saturate(1951%) hue-rotate(178deg) brightness(57%) contrast(96%);
}

@keyframes styles_oceanWave__l6tip {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  25% {
    transform: translateY(-2px) rotate(0deg);
  }
  50% {
    transform: translateY(0) rotate(0deg);
  }
  75% {
    transform: translateY(-2px) rotate(0deg);
  }
}
.styles_descriptionLabel__Jikp9 {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  color: black;
  margin-bottom: 2px;
  letter-spacing: 0.5px;
}

.styles_descriptionContent__bCv0z {
  min-height: 40px;
  display: flex;
  align-items: center;
}

.styles_expandedDescription__yboe0 {
  font-size: 16px;
}

.styles_descriptionText__HzdCG {
  font-size: 16px;
  line-height: 1.5;
  color: var(--color-text-primary);
  margin: 0;
  font-style: italic;
}

.styles_expandedContent__Ihd5Y {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--color-border-light, rgba(0, 0, 0, 0.1));
  animation: styles_slideIn__CgZ7g 0.3s ease;
}

@keyframes styles_slideIn__CgZ7g {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.styles_courseDetails__S5IjV {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 24px;
}
@media (min-width: 640px) {
  .styles_courseDetails__S5IjV {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1024px) {
  .styles_courseDetails__S5IjV {
    grid-template-columns: repeat(3, 1fr);
  }
}

.styles_detailItem__y2Rlt {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.styles_detailIcon__sX6NY {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-background-secondary, rgba(0, 0, 0, 0.05));
  border-radius: 6px;
  font-size: 14px;
  flex-shrink: 0;
}

.styles_detailText__gBTfm {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
}

.styles_detailLabel__7pVcM {
  font-size: 12px;
  color: var(--color-text-tertiary, #94a3b8);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.styles_detailValue__rTpHd {
  font-size: 16px;
  color: var(--color-text-primary);
  font-weight: 500;
}

.styles_oceanLogo__kpvhw {
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-top: 1px;
  margin-right: 2px;
  flex-shrink: 0;
  position: relative;
  top: 5px;
}

.styles_oceanLogoExpanded__KOzjR {
  width: 30px;
  height: 30px;
  object-fit: contain;
  margin-top: 1px;
  margin-right: 2px;
  flex-shrink: 0;
  position: relative;
  bottom: 3px;
}

.styles_locationIcon__DRoUp {
  width: 18px;
  height: 18px;
  object-fit: contain;
  margin-right: 3px;
  margin-top: 8px;
  position: relative;
  top: 3px;
  opacity: 0.7;
}

.styles_locationIconExpanded__kE7wr {
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-right: -4px;
  margin-top: 4px;
  position: relative;
  bottom: 3px;
  opacity: 0.7;
}

.styles_actionButtons__y-4aD {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  justify-content: center;
}
.styles_actionButtons__y-4aD button {
  width: auto;
  flex: 0 0 auto;
  min-width: 140px;
}

.styles_lastUpdated__36R78 {
  text-align: center;
  margin-top: 4px;
  padding-top: 4px;
}

.styles_lastUpdatedLabel__9Oiv5 {
  font-size: 11px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-right: 4px;
}

.styles_lastUpdatedValue__TozRG {
  font-size: 11px;
  color: #94a3b8;
}

.styles_typingCursor__ZyKdS {
  animation: styles_blink__eZp2X 1s infinite;
  font-weight: 400;
  color: var(--color-text-primary);
}

@keyframes styles_blink__eZp2X {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
}
.styles_uploadLoader__2FyGk {
  width: 28px;
  height: 32px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0px;
  flex-shrink: 0;
  overflow: hidden;
}

.styles_dots__tBDC6 {
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: absolute;
  margin-left: 8px;
  transform: translate(-5%, -5%);
}

.styles_dot__C-Vww {
  width: 3px;
  height: 3px;
  background: #0a4eae;
  border-radius: 50%;
  animation: styles_moveUpFlow__UqFfR 1.5s ease-in-out infinite;
}
.styles_dot__C-Vww:nth-child(1) {
  animation-delay: 0s;
}
.styles_dot__C-Vww:nth-child(2) {
  animation-delay: 0.1s;
}
.styles_dot__C-Vww:nth-child(3) {
  animation-delay: 0.2s;
}
.styles_dot__C-Vww:nth-child(4) {
  animation-delay: 0.3s;
}
.styles_dot__C-Vww:nth-child(5) {
  animation-delay: 0.4s;
}

@keyframes styles_moveUpFlow__UqFfR {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    transform: translateY(-10px);
    opacity: 0;
  }
}
.styles_arrow__HHH2P {
  position: absolute;
  font-size: 28px;
  color: #0a4eae;
  font-weight: bold;
  animation: styles_moveUpDots__kkhOQ 1.2s ease-in-out infinite;
  animation-delay: 0.5s;
  margin-left: 8px;
}

@keyframes styles_moveUpDots__kkhOQ {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    transform: translateY(-10px);
    opacity: 0;
  }
}
.styles_locationInputWrapper__9U6M1 {
  flex: 1 1;
  position: relative;
}

.styles_locationInput__vi\\+Pn {
  width: 100%;
  border: none;
  background: transparent;
  font-size: 16px;
  color: var(--color-text-primary);
  font-weight: 500;
  padding: 4px 8px;
  margin: -4px -8px;
  border-radius: 4px;
  outline: none;
  cursor: text;
  transition: all 0.2s ease;
}
.styles_locationInput__vi\\+Pn::placeholder {
  color: rgba(0, 0, 0, 0.4);
}
.styles_locationInput__vi\\+Pn:hover {
  background: rgba(0, 0, 0, 0.05);
}
.styles_locationInput__vi\\+Pn:focus {
  background: white;
  box-shadow: 0 0 0 2px var(--focus-shadow, rgba(3, 155, 229, 0.3));
  border-color: var(--focus-color, #039be5);
  cursor: text;
  margin-left: 2px;
}

.styles_tasksSection__1I4GL {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.styles_tasksLabel__mzGIw {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  color: black;
  letter-spacing: 0.5px;
  margin: 0 0 2px 0;
}

.styles_tasksList__UDwyb {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 4px 4px 2px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 180px;
}
.styles_tasksList__UDwyb::-webkit-scrollbar {
  width: 6px;
}
.styles_tasksList__UDwyb::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.styles_tasksList__UDwyb::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.styles_tasksList__UDwyb::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
.styles_tasksList__UDwyb {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);
}

.styles_taskItem__cP44n {
  padding: 12px;
  border: 1px solid rgba(0, 0, 0, 0.45);
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.styles_taskItem__cP44n:hover {
  border-color: rgba(0, 0, 0, 0.65);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.styles_taskTitle__hbi3N {
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-primary);
  margin: 0;
  line-height: 1.4;
}

.styles_taskDueDate__\\+GrT5 {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
  line-height: 1.3;
}

.styles_seeFullTaskListButton__WN9JG {
  padding: 6px 16px;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-primary);
  width: fit-content;
  margin-top: 12px;
}
.styles_seeFullTaskListButton__WN9JG:hover {
  background: rgba(0, 0, 0, 0.03);
  border-color: rgba(0, 0, 0, 0.5);
}
.styles_seeFullTaskListButton__WN9JG .styles_expandIcon__xTVT2 {
  width: 11px;
  height: 11px;
}

.styles_sectionChangeWarning__egFjO {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 15px;
  padding: 8px 0;
  animation: styles_fadeIn__lACu2 0.3s ease-in-out;
}
.styles_sectionChangeWarning__egFjO .styles_infoIcon__YKcs3 {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  position: relative;
  top: 2px;
}

@keyframes styles_fadeIn__lACu2 {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.styles_animatedBorderButton__h7-Ne {
  position: relative;
  background: linear-gradient(white, white) padding-box, linear-gradient(90deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)) border-box;
  border: 2px solid transparent !important;
  border-radius: 8px;
}
.styles_animatedBorderButton__h7-Ne::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 2px;
  background: var(--border-color, #039be5);
  border-radius: 2px;
  animation: styles_borderTravelTop__X3mA4 2s linear infinite;
  box-shadow: 0 0 8px var(--border-color, #039be5);
}
.styles_animatedBorderButton__h7-Ne::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 2px;
  background: var(--border-color, #039be5);
  border-radius: 2px;
  animation: styles_borderTravelBottom__RbWHl 2s linear infinite;
  box-shadow: 0 0 8px var(--border-color, #039be5);
}

@keyframes styles_borderTravelTop__X3mA4 {
  0% {
    top: -2px;
    left: 0;
    width: 20px;
    height: 2px;
  }
  25% {
    top: -2px;
    left: calc(100% - 24px);
    width: 20px;
    height: 2px;
  }
  25.1% {
    top: 0;
    left: calc(100% - 0px);
    width: 2px;
    height: 20px;
  }
  50% {
    top: calc(100% - 22px);
    left: calc(100% - 0px);
    width: 2px;
    height: 20px;
  }
  50.1% {
    top: calc(100% - 0px);
    left: calc(100% - 22px);
    width: 20px;
    height: 2px;
  }
  75% {
    top: calc(100% - 0px);
    left: 0;
    width: 20px;
    height: 2px;
  }
  75.1% {
    top: calc(100% - 24px);
    left: -2px;
    width: 2px;
    height: 20px;
  }
  100% {
    top: 2px;
    left: -2px;
    width: 2px;
    height: 20px;
  }
}
.styles_exitTasksButton__jWyip {
  padding: 6px 16px;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-primary);
  width: fit-content;
  margin-left: auto;
}
.styles_exitTasksButton__jWyip:hover {
  background: rgba(0, 0, 0, 0.03);
  border-color: rgba(0, 0, 0, 0.5);
}
.styles_exitTasksButton__jWyip .styles_minimizeIcon__icuQb {
  width: 16px;
  height: 16px;
}

.styles_noTasksMessage__P7jEt {
  padding: 12px;
  text-align: center;
  font-size: 12px;
  color: #6b7280;
  font-style: italic;
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.styles_tasksLoading__iWQk7 {
  padding: 12px;
  text-align: center;
  font-size: 12px;
  color: #6b7280;
  font-style: italic;
}

.styles_tasksFocusedView__tGH2a {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.styles_tasksFocusedHeader__ypuuo {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  color: black;
  letter-spacing: 0.5px;
  margin: 0;
}

.styles_tasksColumnsContainer__GMhOa {
  display: flex;
  gap: 40px;
  flex-direction: column;
}
@media (min-width: 640px) {
  .styles_tasksColumnsContainer__GMhOa {
    flex-direction: row;
  }
}

.styles_tasksColumn__KJdHW {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.styles_columnTitle__\\+Bl4W {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0;
}

.styles_tasksCategorySection__RM9DE {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.styles_categoryTitle__i8yp5 {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 4px;
}

.styles_categoryDivider__7O1Wv {
  width: 100%;
  height: 1px;
  background: rgba(0, 0, 0, 0.2);
  margin-bottom: 8px;
}

.styles_tasksListFocused__tpmaX {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 2px 4px 0 2px;
  max-height: 500px;
  overflow-y: auto;
}
.styles_tasksListFocused__tpmaX::-webkit-scrollbar {
  width: 6px;
}
.styles_tasksListFocused__tpmaX::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.styles_tasksListFocused__tpmaX::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.styles_tasksListFocused__tpmaX::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.styles_taskItemFocused__vfO0R {
  padding: 12px;
  border: 1px solid rgba(0, 0, 0, 0.45);
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.styles_taskItemFocused__vfO0R:hover {
  border-color: rgba(0, 0, 0, 0.65);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.styles_taskItemContent__YLwHT {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.styles_taskToggleButton__7YzGn {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.5);
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-top: 2px;
}
.styles_taskToggleButton__7YzGn:hover {
  border-color: rgba(0, 0, 0, 0.7);
  background: rgba(0, 0, 0, 0.03);
}
.styles_taskToggleButton__7YzGn:active {
  transform: scale(0.95);
}
.styles_taskToggleButton__7YzGn.styles_checked__iDLkq {
  border-color: transparent;
  background: transparent;
}
.styles_taskToggleButton__7YzGn.styles_checked__iDLkq:hover {
  background: transparent;
}

.styles_checkIcon__gw4Mg {
  width: 18px;
  height: 18px;
  color: rgba(0, 0, 0, 0.5);
  stroke-width: 2.5;
}

.styles_taskContent__uVzXN {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.styles_emptyTasksMessage__wMR4l {
  padding: 8px 12px;
  font-size: 12px;
  color: #6b7280;
  font-style: italic;
}

@keyframes styles_borderTravelBottom__RbWHl {
  0% {
    bottom: -2px;
    right: 0px;
    width: 20px;
    height: 2px;
  }
  25% {
    bottom: -2px;
    right: calc(100% - 20px);
    width: 20px;
    height: 2px;
  }
  25.1% {
    bottom: 2px;
    right: calc(100% - 0px);
    width: 2px;
    height: 20px;
  }
  50% {
    bottom: calc(100% - 22px);
    right: calc(100% - 0px);
    width: 2px;
    height: 20px;
  }
  50.1% {
    bottom: calc(100% - 0px);
    right: calc(100% - 20px);
    width: 20px;
    height: 2px;
  }
  75% {
    bottom: calc(100% - 0px);
    right: 0;
    width: 20px;
    height: 2px;
  }
  75.1% {
    bottom: calc(100% - 20px);
    right: -2px;
    width: 2px;
    height: 20px;
  }
  100% {
    bottom: 4px;
    right: -2px;
    width: 2px;
    height: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/course-card/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACI,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EAEA,YAAA;EACA,aAAA;EACA,sBAAA;AADJ;AAII;EACE,eAAA;AAFN;AAKI;EACE,YAAA;EACA,kBAAA;AAHN;;AAQA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,yBAAA;AALF;;AASA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,yBAAA;AANF;;AASE;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AANJ;;AASA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AANJ;AC3DE;ED0DF;IAUM,WAAA;IACA,YAAA;EALJ;AACF;;AAWA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AARJ;;AAWA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AARJ;;AAYE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AATJ;;AAaE;EACE,kBAAA;AAVJ;;AAaE;EACE,kBAAA;EACA,QAAA;AAVJ;;AAaE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAVJ;;AAaE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AAVJ;AAYI;EACE,sBAAA;EACA,yCAAA;AAVN;AAaI;EACE,sBAAA;AAXN;;AAeE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AAZJ;AAcI;EACE,sBAAA;EACA,yCAAA;AAZN;AAeI;EACE,sBAAA;AAbN;;AAiBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,wCAAA;AAdJ;AAgBI;EACE,qBAAA;EACA,yCAAA;AAdN;;AAkBE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,0CAAA;EACA,aAAA;EACA,qCAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;AAfJ;;AAmBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,0CAAA;EACA,aAAA;EACA,qCAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AAhBJ;;AAmBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,0CAAA;EACA,aAAA;EACA,qCAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AAhBJ;;AAmBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBJ;AAkBI;EACE,qBAAA;EACA,gCAAA;AAhBN;AAmBI;EACE,iDAAA;AAjBN;;AAqBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlBJ;AAoBI;EACE,qBAAA;EACA,gCAAA;AAlBN;AAqBI;EACE,iDAAA;AAnBN;;AAuBE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AApBJ;;AAuBE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;AApBJ;AAsBI;EACE,UAAA;AApBN;;AAwBE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,SAAA;AArBJ;;AAwBE;EACE,wMAAA;EAMA,0BAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,wDAAA;AA1BJ;;AA6BE;EACE;IACE,4BAAA;EA1BJ;EA4BE;IACE,2BAAA;EA1BJ;EA4BE;IACE,4BAAA;EA1BJ;AACF;AA6BE;EACE,WAAA;EACA,8BAAA;EACA,cAAA;AA3BJ;;AA+BE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AA5BJ;AA8BI;EACE,kCAAA;EACA,yDAAA;AA5BN;;AAiCE;EACE,eAAA;EACA,kCAAA;EACA,cAAA;EACA,mBAAA;AA9BJ;;AAkCE;EACE,kBAAA;AA/BJ;;AAkCE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AA/BJ;;AAmCE;EACE,aAAA;AAhCJ;;AAmCE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;AAhCJ;ACzUE;EDqWA;IAQI,mBAAA;IACA,SAAA;EAhCJ;AACF;;AAmCE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAhCJ;;AAmCE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAhCJ;;AAmCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAhCJ;;AAmCE;EACE,eAAA;EACA,YAAA;AAhCJ;;AAmCE;EACE,eAAA;EACA,gCAAA;AAhCJ;;AAmCE;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAhCJ;;AAmCE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAhCJ;;AAmCE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,0DAAA;AAhCJ;AAmCI;EACE,eAAA;AAjCN;;AAqCE;EACE;IACE,YAAA;EAlCJ;EAoCE;IACE,UAAA;EAlCJ;AACF;AAqCE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAnCJ;;AAsCE;EACE,WAAA;EACA,YAAA;EACA,4DAAA;EAGA,4HAAA;AArCJ;;AAyCE;EACE;IACE,qCAAA;EAtCJ;EAwCE;IACE,wCAAA;EAtCJ;EAwCE;IACE,qCAAA;EAtCJ;EAwCE;IACE,wCAAA;EAtCJ;AACF;AAyCA;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AAvCJ;;AA0CE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAvCJ;;AA0CE;EACE,eAAA;AAvCJ;;AA2CE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,SAAA;EACA,kBAAA;AAxCJ;;AA4CE;EACE,gBAAA;EACA,iBAAA;EACA,mEAAA;EACA,0CAAA;AAzCJ;;AA4CE;EACE;IACE,UAAA;IACA,4BAAA;EAzCJ;EA2CE;IACE,UAAA;IACA,wBAAA;EAzCJ;AACF;AA4CE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,mBAAA;AA1CJ;AC7dE;EDmgBA;IAOI,qCAAA;EAzCJ;AACF;ACtdE;EDufA;IAWI,qCAAA;EAxCJ;AACF;;AA2CE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAxCJ;;AA2CE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kEAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAxCJ;;AA2CE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;AAxCJ;;AA2CE;EACE,eAAA;EACA,0CAAA;EACA,yBAAA;EACA,qBAAA;AAxCJ;;AA2CE;EACE,eAAA;EACA,gCAAA;EACA,gBAAA;AAxCJ;;AA2CE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;AAxCJ;;AA2CE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AAxCJ;;AA2CE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AAxCJ;;AA2CE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAxCJ;;AA2CE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;AAxCJ;AA0CI;EACE,WAAA;EACA,cAAA;EACA,gBAAA;AAxCN;;AA4CE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAzCJ;;AA4CE;EACE,eAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;AAzCJ;;AA4CE;EACE,eAAA;EACA,cAAA;AAzCJ;;AA4CE;EACE,0CAAA;EACA,gBAAA;EACA,gCAAA;AAzCJ;;AA4CE;EACE;IACE,UAAA;EAzCJ;EA2CE;IACE,UAAA;EAzCJ;AACF;AA6CE;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,kBAAA;EACA,cAAA;EACA,gBAAA;AA5CF;;AA+CA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;AA5CF;;AA+CA;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,6DAAA;AA5CF;AA8CE;EAAiB,mBAAA;AA3CnB;AA4CE;EAAiB,qBAAA;AAzCnB;AA0CE;EAAiB,qBAAA;AAvCnB;AAwCE;EAAiB,qBAAA;AArCnB;AAsCE;EAAiB,qBAAA;AAnCnB;;AAqCA;EACE;IACE,2BAAA;IACA,UAAA;EAlCF;EAoCA;IACE,UAAA;EAlCF;EAoCA;IACE,UAAA;EAlCF;EAoCA;IACE,4BAAA;IACA,UAAA;EAlCF;AACF;AAqCA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,6DAAA;EACA,qBAAA;EACA,gBAAA;AAnCF;;AAsCA;EACE;IACE,2BAAA;IACA,UAAA;EAnCF;EAqCA;IACE,UAAA;EAnCF;EAqCA;IACE,UAAA;EAnCF;EAqCA;IACE,4BAAA;IACA,UAAA;EAnCF;AACF;AAsCA;EACE,SAAA;EACA,kBAAA;AApCF;;AAuCA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;AApCF;AAsCE;EACE,yBAAA;AApCJ;AAuCE;EACE,+BAAA;AArCJ;AAwCE;EACE,iBAAA;EACA,iEAAA;EACA,yCAAA;EACA,YAAA;EACA,gBAAA;AAtCJ;;AA2CA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAxCF;;AA2CA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;AAxCF;;AA2CA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAxCF;AA0CE;EACE,UAAA;AAxCJ;AA2CE;EACE,+BAAA;EACA,kBAAA;AAzCJ;AA4CE;EACE,8BAAA;EACA,kBAAA;AA1CJ;AA4CI;EACE,8BAAA;AA1CN;AAmBA;EA4BE,qBAAA;EACA,uDAAA;AA5CF;;AA+CA;EACE,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA5CF;AA8CE;EACE,iCAAA;EACA,yCAAA;EACA,2BAAA;AA5CJ;;AAgDA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,SAAA;EACA,gBAAA;AA7CF;;AAgDA;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AA7CF;;AAgDA;EACE,iBAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AA7CF;AA+CE;EACE,+BAAA;EACA,gCAAA;AA7CJ;AAgDE;EACE,WAAA;EACA,YAAA;AA9CJ;;AAmDA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,gDAAA;AAhDF;AAkDE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;AAhDJ;;AAoDA;EACE;IACE,UAAA;IACA,2BAAA;EAjDF;EAmDA;IACE,UAAA;IACA,wBAAA;EAjDF;AACF;AAqDA;EACE,kBAAA;EACA,gIACE;EAEF,wCAAA;EACA,kBAAA;AArDF;AAuDE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,2DAAA;EACA,gDAAA;AArDJ;AAwDE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,8DAAA;EACA,gDAAA;AAtDJ;;AA0DA;EACE;IACE,SAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;EAvDF;EAyDA;IACE,SAAA;IACA,uBAAA;IACA,WAAA;IACA,WAAA;EAvDF;EAyDA;IACE,MAAA;IACA,sBAAA;IACA,UAAA;IACA,YAAA;EAvDF;EAyDA;IACE,sBAAA;IACA,sBAAA;IACA,UAAA;IACA,YAAA;EAvDF;EAyDA;IACE,qBAAA;IACA,uBAAA;IACA,WAAA;IACA,WAAA;EAvDF;EAyDA;IACE,qBAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;EAvDF;EAyDA;IACE,sBAAA;IACA,UAAA;IACA,UAAA;IACA,YAAA;EAvDF;EAyDA;IACE,QAAA;IACA,UAAA;IACA,UAAA;IACA,YAAA;EAvDF;AACF;AA0DA;EACE,iBAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;AAxDF;AA0DE;EACE,+BAAA;EACA,gCAAA;AAxDJ;AA2DE;EACE,WAAA;EACA,YAAA;AAzDJ;;AA6DA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,oCAAA;EACA,kBAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AA1DF;;AA8DA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA3DF;;AA8DA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,SAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,SAAA;EACA,sBAAA;AA3DF;ACh/BE;EDwiCF;IAMI,mBAAA;EA1DF;AACF;;AA6DA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,SAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;AA1DF;;AA6DA;EACE,WAAA;EACA,WAAA;EACA,8BAAA;EACA,kBAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AA1DF;AA4DE;EACE,UAAA;AA1DJ;AA6DE;EACE,+BAAA;EACA,kBAAA;AA3DJ;AA8DE;EACE,8BAAA;EACA,kBAAA;AA5DJ;AA8DI;EACE,8BAAA;AA5DN;;AAiEA;EACE,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AA9DF;AAgEE;EACE,iCAAA;EACA,yCAAA;EACA,2BAAA;AA9DJ;;AAkEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AA/DF;;AAkEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;AA/DF;AAiEE;EACE,gCAAA;EACA,+BAAA;AA/DJ;AAkEE;EACE,sBAAA;AAhEJ;AAmEE;EACE,yBAAA;EACA,uBAAA;AAjEJ;AAmEI;EACE,uBAAA;AAjEN;;AAsEA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;AAnEF;;AAsEA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAnEF;;AAsEA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAnEF;;AAsEA;EACE;IACE,YAAA;IACA,UAAA;IACA,WAAA;IACA,WAAA;EAnEF;EAqEA;IACE,YAAA;IACA,wBAAA;IACA,WAAA;IACA,WAAA;EAnEF;EAqEA;IACE,WAAA;IACA,uBAAA;IACA,UAAA;IACA,YAAA;EAnEF;EAqEA;IACE,yBAAA;IACA,uBAAA;IACA,UAAA;IACA,YAAA;EAnEF;EAqEA;IACE,wBAAA;IACA,wBAAA;IACA,WAAA;IACA,WAAA;EAnEF;EAqEA;IACE,wBAAA;IACA,QAAA;IACA,WAAA;IACA,WAAA;EAnEF;EAqEA;IACE,yBAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;EAnEF;EAqEA;IACE,WAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;EAnEF;AACF","sourcesContent":["@import \"mixins\";\n.courseCard {\n    border-radius: 12px;\n    padding: 20px;\n    transition: all 0.3s ease;\n    cursor: pointer;\n    position: relative;\n    background: white;\n    //overflow: visible;\n    height: 100%; // Add this\n    display: flex; // Add this\n    flex-direction: column; // Add this\n  \n    \n    &.expanded {\n      cursor: default;\n    }\n    \n    &.deleted {\n      opacity: 0.6;\n      position: relative;\n      \n    }\n  }\n\n.crossoutOverlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 60px;  \n  height: 60px;\n  opacity: 0.8;\n  pointer-events: none; // Allows clicks to pass through\n  z-index: 10;\n  transition: all 0.3s ease; // Smooth transition when expanding\n\n}\n\n.crossoutOverlayExpanded {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100px;  // Larger size when expanded\n  height: 100px;\n  opacity: 0.8;\n  pointer-events: none;\n  z-index: 10;\n  transition: all 0.3s ease;\n}\n  \n  .cardContent {\n    position: relative;\n    flex: 1; // Add this to make content fill available space\n    display: flex; // Add this\n    flex-direction: column; // Add this\n  }\n  \n.calendarIcon {\n    width: 30px;\n    height: 30px;\n    object-fit: contain;\n    opacity: 0.9;\n    flex-shrink: 0;\n    position: relative;\n    bottom: 3px;  // Shifts the icon up by 3\n\n    @include sm {\n      width: 30px;\n      height: 30px;\n    }\n\n  }\n  \n\n  // Collapsed state header\n.courseHeaderCollapsed {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 12px;\n    padding-right: 40px; // Add padding to prevent overlap with color picker\n  }\n\n.courseHeader {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 16px;\n  }\n  \n  // Simple color dot for collapsed state\n  .colorDot {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    flex-shrink: 0;\n  }\n  \n  // Color picker for expanded state\n  .colorPickerContainer {\n    position: relative;\n  }\n\n  .colorPickerContainerExpanded {\n    position: relative;\n    top: 3px;\n  }\n\n  .colorPickerWrapper {\n    position: absolute;\n    top: -5px;\n    right: 0px;\n    z-index: 2;\n  }\n  \n  .colorButton {\n    width: 22px;\n    height: 22px;\n    border-radius: 4px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s;\n    position: relative;\n    \n    &:hover {\n      transform: scale(1.05);\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    }\n    \n    &:active {\n      transform: scale(0.95);\n    }\n  }\n\n  .colorButtonExpanded {\n    width: 22px;\n    height: 22px;\n    border-radius: 4px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s;\n    position: relative;\n    \n    &:hover {\n      transform: scale(1.05);\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    }\n    \n    &:active {\n      transform: scale(0.95);\n    }\n  }\n\n  .colorButtonTop {\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    \n    &:hover {\n      transform: scale(1.1);\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    }\n  }\n  \n  .colorPaletteTop {\n    position: absolute;\n    top: 0px;\n    right: 30px;\n    background: white;\n    border-radius: 8px;\n    padding: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 5px;\n    z-index: 100;\n    min-width: 30px;\n  }\n\n  \n  .colorPalette {\n    position: absolute;\n    top: 40px;\n    left: 0;\n    background: white;\n    border-radius: 8px;\n    padding: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 6px;\n    z-index: 100;\n    min-width: 100px;\n  }\n\n  .colorPaletteExpanded {\n    position: absolute;\n    top: 40px;\n    left: 0;\n    background: white;\n    border-radius: 8px;\n    padding: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 6px;\n    z-index: 100;\n    min-width: 100px;\n  }\n  \n  .colorOption {\n    width: 22px;\n    height: 22px;\n    border-radius: 6px;\n    border: 2px solid transparent;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    \n    &:hover {\n      transform: scale(1.1);\n      border-color: rgba(0, 0, 0, 0.2);\n    }\n    \n    svg {\n      filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));\n    }\n  }\n\n  .colorOptionExpanded {\n    width: 22px;\n    height: 22px;\n    border-radius: 6px;\n    border: 2px solid transparent;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    \n    &:hover {\n      transform: scale(1.1);\n      border-color: rgba(0, 0, 0, 0.2);\n    }\n    \n    svg {\n      filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));\n    }\n  }\n  \n  .courseTitleContainer {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .editIcon {\n    width: 20px;\n    height: 20px;\n    opacity: 0.6;\n    cursor: pointer;\n    transition: opacity 0.2s;\n    \n    &:hover {\n      opacity: 1;\n    }\n  }\n  \n  .courseName {\n    font-size: 18px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n    margin: 0;\n  }\n\n  .courseHeaderCollapsed .courseName.updating {\n    background: linear-gradient(90deg,\n      var(--course-color, #039be5) 0%,\n      var(--course-color, #039be5) 40%,\n      rgba(255, 255, 255, 0.3) 50%,\n      var(--course-color, #039be5) 60%,\n      var(--course-color, #039be5) 100%);\n    background-size: 200% 100%;\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    animation: shimmer 3s ease-in-out infinite;\n  }\n\n  @keyframes shimmer {\n    0% {\n      background-position: -100% 0;\n    }\n    50% {\n      background-position: 100% 0;\n    }\n    100% {\n      background-position: -100% 0;\n    }\n  }\n\n  .divider {\n    height: 1px;\n    background: rgba(0, 0, 0, 0.1);\n    margin: 12px 0;\n  }\n  \n  \n  .courseNameInput {\n    flex: 1;\n    font-size: 18px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    padding: 4px 8px;\n    outline: none;\n    \n    &:focus {\n      border-color: var(--color-primary);\n      box-shadow: 0 0 0 2px rgba(var(--color-primary-rgb), 0.2);\n    }\n  }\n  \n  // Section display for collapsed state\n  .sectionDisplay {\n    font-size: 14px;\n    color: var(--color-text-secondary);\n    padding: 8px 0;\n    margin-bottom: 12px;\n  }\n  \n  // Section selector for expanded state\n  .sectionSelector {\n    margin-bottom: 0px;  \n}\n\n  .sectionRow {\n    display: flex;\n    gap: 16px;\n    margin-bottom: 16px;\n    align-items: center;\n  }\n  \n  // Preview state (collapsed)\n  .cardPreview {\n    display:none;\n  }\n\n  .infoRow {\n    display: flex;\n    gap: 40px;\n    margin-bottom: 20px;\n    flex-direction: column; // Stack vertically by default (mobile)\n\n  \n    @include sm {\n      flex-direction: row; // Side by side on larger screens\n      gap: 40px;\n    }\n  }\n  \n  .leftColumn {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n  }\n\n  .rightColumn {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n  }\n  \n  .previewInfo {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .scheduleIcon {\n    font-size: 14px;\n    opacity: 0.7;\n  }\n  \n  .scheduleText {\n    font-size: 16px;\n    color: var(--color-text-primary);\n  }\n  \n  .smartDescription {\n    padding: 12px 1px;\n    min-height: 48px;\n    display: flex;\n    align-items: center;\n  }\n\n  .descriptionLoading {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n  }\n\n  .loadingText {\n    color: #6b7280;\n    font-size: 13px;\n    font-style: italic;\n    animation: fadeInOut 2s ease-in-out infinite;\n    \n    // Slightly larger in expanded view\n    .expandedDescription & {\n      font-size: 14px;\n    }\n  }\n  \n  @keyframes fadeInOut {\n    0%, 100% {\n      opacity: 0.6;\n    }\n    50% {\n      opacity: 1;\n    }\n  }\n\n  .oceanLogoWrapper {\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n  }\n  \n  .oceanLogoSpinner {\n    width: 100%;\n    height: 100%;\n    animation: oceanWave 1.5s ease-in-out infinite;\n    \n    // Apply Ocean blue color filter\n    filter: brightness(0) saturate(100%) invert(54%) sepia(85%) saturate(1951%) \n           hue-rotate(178deg) brightness(57%) contrast(96%);\n  }\n  \n  @keyframes oceanWave {\n    0%, 100% {\n      transform: translateY(0) rotate(0deg);\n    }\n    25% {\n      transform: translateY(-2px) rotate(0deg);\n    }\n    50% {\n      transform: translateY(0) rotate(0deg);\n    }\n    75% {\n      transform: translateY(-2px) rotate(0deg);\n    }\n  }\n\n.descriptionLabel {\n    font-size: 14px;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: black;\n    margin-bottom: 2px;\n    letter-spacing: 0.5px;\n  }\n\n  .descriptionContent {\n    min-height: 40px;\n    display: flex;\n    align-items: center;\n  }\n\n  .expandedDescription {\n    font-size: 16px;\n  }\n  \n  \n  .descriptionText {\n    font-size: 16px;\n    line-height: 1.5;\n    color: var(--color-text-primary);\n    margin: 0;\n    font-style: italic;\n  }\n  \n  // Expanded state\n  .expandedContent {\n    margin-top: 20px;\n    padding-top: 20px;\n    border-top: 1px solid var(--color-border-light, rgba(0, 0, 0, 0.1));\n    animation: slideIn 0.3s ease;\n  }\n  \n  @keyframes slideIn {\n    from {\n      opacity: 0;\n      transform: translateY(-10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  .courseDetails {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 16px;\n    margin-bottom: 24px;\n    \n    @include sm {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    \n    @include lg {\n      grid-template-columns: repeat(3, 1fr);\n    }\n  }\n  \n  .detailItem {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .detailIcon {\n    width: 28px;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--color-background-secondary, rgba(0, 0, 0, 0.05));\n    border-radius: 6px;\n    font-size: 14px;\n    flex-shrink: 0;\n  }\n  \n  .detailText {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    flex: 1;\n  }\n  \n  .detailLabel {\n    font-size: 12px;\n    color: var(--color-text-tertiary, #94a3b8);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n  \n  .detailValue {\n    font-size: 16px;\n    color: var(--color-text-primary);\n    font-weight: 500;\n  }\n\n  .oceanLogo {\n    width: 20px;\n    height: 20px;\n    object-fit: contain;\n    margin-top: 1px;\n    margin-right: 2px;\n    flex-shrink: 0;\n    position: relative;\n    top: 5px;  // Shifts the icon down by 2\n  }\n\n  .oceanLogoExpanded {\n    width: 30px;\n    height: 30px;\n    object-fit: contain;\n    margin-top: 1px;\n    margin-right: 2px;\n    flex-shrink: 0;\n    position: relative;\n    bottom: 3px;  // Shifts the icon down by 2\n  }\n\n  .locationIcon {\n    width: 18px;\n    height: 18px;\n    object-fit: contain;\n    margin-right: 3px;\n    margin-top: 8px;\n    position: relative;\n    top: 3px;  // Shifts the icon down by 2\n    opacity: 0.7;\n  }\n  \n  .locationIconExpanded {\n    width: 20px;\n    height: 20px;\n    object-fit: contain;\n    margin-right: -4px;\n    margin-top: 4px;\n    position: relative;\n    bottom: 3px;  \n    opacity: 0.7;\n  }\n\n  .actionButtons {\n    display: flex;\n    gap: 12px;\n    margin-top: 20px;\n    justify-content: center; // Centers the buttons\n    \n    button {\n      width: auto; // Override the default 100% width\n      flex: 0 0 auto; // Prevent stretching\n      min-width: 140px; // Ensure consistent button width\n    }\n  }\n\n  .lastUpdated {\n    text-align: center;\n    margin-top: 4px;\n    padding-top: 4px;\n  }\n  \n  .lastUpdatedLabel {\n    font-size: 11px;\n    color: #94a3b8;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-right: 4px; // Adds space between label and date\n}\n  \n  .lastUpdatedValue {\n    font-size: 11px;\n    color: #94a3b8;\n  }\n\n  .typingCursor {\n    animation: blink 1s infinite;\n    font-weight: 400;\n    color: var(--color-text-primary);\n  }\n  \n  @keyframes blink {\n    0%, 50% {\n      opacity: 1;\n    }\n    51%, 100% {\n      opacity: 0;\n    }\n  }\n\n\n  .uploadLoader {\n  width: 28px;\n  height: 32px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  //background: var(--color-background-secondary, rgba(0, 0, 0, 0.05));\n  border-radius: 0px;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.dots {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  position: absolute;\n  margin-left: 8px;\n  transform: translate(-5%, -5%);\n}\n\n.dot {\n  width: 3px;\n  height: 3px;\n  background: #0a4eae;\n  border-radius: 50%;\n  animation: moveUpFlow 1.5s ease-in-out infinite;\n  \n  &:nth-child(1) { animation-delay: 0s; }\n  &:nth-child(2) { animation-delay: 0.1s; }\n  &:nth-child(3) { animation-delay: 0.2s; }\n  &:nth-child(4) { animation-delay: 0.3s; }\n  &:nth-child(5) { animation-delay: 0.4s; }\n}\n@keyframes moveUpFlow {\n  0% { \n    transform: translateY(10px); \n    opacity: 0; \n  }\n  20% { \n    opacity: 1; \n  }\n  80% { \n    opacity: 1; \n  }\n  100% { \n    transform: translateY(-10px); \n    opacity: 0; \n  }\n}\n\n.arrow {\n  position: absolute;\n  font-size: 28px;\n  color: #0a4eae;\n  font-weight: bold;\n  animation: moveUpDots 1.2s ease-in-out infinite;\n  animation-delay: 0.5s;\n  margin-left: 8px;\n}\n\n@keyframes moveUpDots {\n  0% { \n    transform: translateY(10px); \n    opacity: 0; \n  }\n  20% { \n    opacity: 1; \n  }\n  80% { \n    opacity: 1; \n  }\n  100% { \n    transform: translateY(-10px); \n    opacity: 0; \n  }\n}\n\n.locationInputWrapper {\n  flex: 1;\n  position: relative;\n}\n\n.locationInput {\n  width: 100%;\n  border: none;\n  background: transparent;\n  font-size: 16px;\n  color: var(--color-text-primary);\n  font-weight: 500;\n  padding: 4px 8px;\n  margin: -4px -8px;\n  border-radius: 4px;\n  outline: none;\n  cursor: text;\n  transition: all 0.2s ease;\n\n  &::placeholder {\n    color: rgba(0, 0, 0, 0.4);\n  }\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.05);\n  }\n\n  &:focus {\n    background: white;\n    box-shadow: 0 0 0 2px var(--focus-shadow, rgba(3, 155, 229, 0.3));\n    border-color: var(--focus-color, #039be5);\n    cursor: text;\n    margin-left: 2px;\n  }\n}\n\n// Tasks Section\n.tasksSection {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.tasksLabel {\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: black;\n  letter-spacing: 0.5px;\n  margin: 0 0 2px 0; // Match descriptionLabel\n}\n\n.tasksList {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 4px 4px 4px 2px; // Add padding to prevent clipping on all sides\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 180px; // Fallback, will be overridden by JavaScript\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.3);\n    }\n  }\n\n  // Firefox\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n}\n\n.taskItem {\n  padding: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.45);\n  border-radius: 30px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  &:hover {\n    border-color: rgba(0, 0, 0, 0.65);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n    transform: translateY(-1px);\n  }\n}\n\n.taskTitle {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  margin: 0;\n  line-height: 1.4;\n}\n\n.taskDueDate {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 0;\n  line-height: 1.3;\n}\n\n.seeFullTaskListButton {\n  padding: 6px 16px;\n  background: white;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  width: fit-content;\n  margin-top: 12px;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.03);\n    border-color: rgba(0, 0, 0, 0.5);\n  }\n\n  .expandIcon {\n    width: 11px;\n    height: 11px;\n  }\n}\n\n// Section change warning message\n.sectionChangeWarning {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 15px;\n  padding: 8px 0;\n  animation: fadeIn 0.3s ease-in-out;\n\n  .infoIcon {\n    width: 18px;\n    height: 18px;\n    flex-shrink: 0;\n    position: relative;\n    top: 2px;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Animated border button for section change upload prompt\n.animatedBorderButton {\n  position: relative;\n  background:\n    linear-gradient(white, white) padding-box,\n    linear-gradient(90deg, rgba(0,0,0,0.1), rgba(0,0,0,0.1)) border-box;\n  border: 2px solid transparent !important;\n  border-radius: 8px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 20px;\n    height: 2px;\n    background: var(--border-color, #039be5);\n    border-radius: 2px;\n    animation: borderTravelTop 2s linear infinite;\n    box-shadow: 0 0 8px var(--border-color, #039be5);\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 20px;\n    height: 2px;\n    background: var(--border-color, #039be5);\n    border-radius: 2px;\n    animation: borderTravelBottom 2s linear infinite;\n    box-shadow: 0 0 8px var(--border-color, #039be5);\n  }\n}\n\n@keyframes borderTravelTop {\n  0% {\n    top: -2px;\n    left: 0;\n    width: 20px;\n    height: 2px;\n  }\n  25% {\n    top: -2px;\n    left: calc(100% - 24px);\n    width: 20px;\n    height: 2px;\n  }\n  25.1% {\n    top: 0;\n    left: calc(100% - 0px);\n    width: 2px;\n    height: 20px;\n  }\n  50% {\n    top: calc(100% - 22px);\n    left: calc(100% - 0px);\n    width: 2px;\n    height: 20px;\n  }\n  50.1% {\n    top: calc(100% - 0px);\n    left: calc(100% - 22px);\n    width: 20px;\n    height: 2px;\n  }\n  75% {\n    top: calc(100% - 0px);\n    left: 0;\n    width: 20px;\n    height: 2px;\n  }\n  75.1% {\n    top: calc(100% - 24px);\n    left: -2px;\n    width: 2px;\n    height: 20px;\n  }\n  100% {\n    top: 2px;\n    left: -2px;\n    width: 2px;\n    height: 20px;\n  }\n}\n\n.exitTasksButton {\n  padding: 6px 16px;\n  background: white;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  width: fit-content;\n  margin-left: auto; // Push to the right\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.03);\n    border-color: rgba(0, 0, 0, 0.5);\n  }\n\n  .minimizeIcon {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.noTasksMessage {\n  padding: 12px;\n  text-align: center;\n  font-size: 12px;\n  color: #6b7280;\n  font-style: italic;\n  background: rgba(0, 0, 0, 0.02);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n}\n\n.tasksLoading {\n  padding: 12px;\n  text-align: center;\n  font-size: 12px;\n  color: #6b7280;\n  font-style: italic;\n}\n\n// Task Focused View Styles\n.tasksFocusedView {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.tasksFocusedHeader {\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: black;\n  letter-spacing: 0.5px;\n  margin: 0;\n}\n\n.tasksColumnsContainer {\n  display: flex;\n  gap: 40px;\n  flex-direction: column;\n\n  @include sm {\n    flex-direction: row;\n  }\n}\n\n.tasksColumn {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.columnTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n.tasksCategorySection {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.categoryTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin-bottom: 4px;\n}\n\n.categoryDivider {\n  width: 100%;\n  height: 1px;\n  background: rgba(0, 0, 0, 0.2);\n  margin-bottom: 8px;\n}\n\n.tasksListFocused {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 2px 4px 0 2px; // Add padding to prevent clipping on hover\n  max-height: 500px; // Increased max-height to accommodate expanded tasks\n  overflow-y: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.3);\n    }\n  }\n}\n\n.taskItemFocused {\n  padding: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.45);\n  border-radius: 30px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    border-color: rgba(0, 0, 0, 0.65);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n    transform: translateY(-1px);\n  }\n}\n\n.taskItemContent {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.taskToggleButton {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid rgba(0, 0, 0, 0.5);\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin-top: 2px;\n\n  &:hover {\n    border-color: rgba(0, 0, 0, 0.7);\n    background: rgba(0, 0, 0, 0.03);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  &.checked {\n    border-color: transparent;\n    background: transparent;\n\n    &:hover {\n      background: transparent;\n    }\n  }\n}\n\n.checkIcon {\n  width: 18px;\n  height: 18px;\n  color: rgba(0, 0, 0, 0.5);\n  stroke-width: 2.5;\n}\n\n.taskContent {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.emptyTasksMessage {\n  padding: 8px 12px;\n  font-size: 12px;\n  color: #6b7280;\n  font-style: italic;\n}\n\n@keyframes borderTravelBottom {\n  0% {\n    bottom: -2px;\n    right: 0px;\n    width: 20px;\n    height: 2px;\n  }\n  25% {\n    bottom: -2px;\n    right: calc(100% - 20px);\n    width: 20px;\n    height: 2px;\n  }\n  25.1% {\n    bottom: 2px;\n    right: calc(100% - 0px);\n    width: 2px;\n    height: 20px;\n  }\n  50% {\n    bottom: calc(100% - 22px);\n    right: calc(100% - 0px);\n    width: 2px;\n    height: 20px;\n  }\n  50.1% {\n    bottom: calc(100% - 0px);\n    right: calc(100% - 20px);\n    width: 20px;\n    height: 2px;\n  }\n  75% {\n    bottom: calc(100% - 0px);\n    right: 0;\n    width: 20px;\n    height: 2px;\n  }\n  75.1% {\n    bottom: calc(100% - 20px);\n    right: -2px;\n    width: 2px;\n    height: 20px;\n  }\n  100% {\n    bottom: 4px;\n    right: -2px;\n    width: 2px;\n    height: 20px;\n  }\n}","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"courseCard": `styles_courseCard__3l2wY`,
	"expanded": `styles_expanded__Jdt5V`,
	"deleted": `styles_deleted__RULEb`,
	"crossoutOverlay": `styles_crossoutOverlay__Ccf72`,
	"crossoutOverlayExpanded": `styles_crossoutOverlayExpanded__oHF-R`,
	"cardContent": `styles_cardContent__X01qM`,
	"calendarIcon": `styles_calendarIcon__048Lo`,
	"courseHeaderCollapsed": `styles_courseHeaderCollapsed__Sr+9H`,
	"courseHeader": `styles_courseHeader__u8GTj`,
	"colorDot": `styles_colorDot__FXKmb`,
	"colorPickerContainer": `styles_colorPickerContainer__wwaOG`,
	"colorPickerContainerExpanded": `styles_colorPickerContainerExpanded__vNXNd`,
	"colorPickerWrapper": `styles_colorPickerWrapper__t3rh3`,
	"colorButton": `styles_colorButton__x9YEN`,
	"colorButtonExpanded": `styles_colorButtonExpanded__I50km`,
	"colorButtonTop": `styles_colorButtonTop__+VclG`,
	"colorPaletteTop": `styles_colorPaletteTop__clcMc`,
	"colorPalette": `styles_colorPalette__WIzIe`,
	"colorPaletteExpanded": `styles_colorPaletteExpanded__FvZ7p`,
	"colorOption": `styles_colorOption__m5+k9`,
	"colorOptionExpanded": `styles_colorOptionExpanded__5d72I`,
	"courseTitleContainer": `styles_courseTitleContainer__3qhdv`,
	"editIcon": `styles_editIcon__R1RFw`,
	"courseName": `styles_courseName__ex33l`,
	"updating": `styles_updating__1kgiR`,
	"shimmer": `styles_shimmer__dyLg3`,
	"divider": `styles_divider__ZTJbY`,
	"courseNameInput": `styles_courseNameInput__Kptze`,
	"sectionDisplay": `styles_sectionDisplay__wpoG8`,
	"sectionSelector": `styles_sectionSelector__w498W`,
	"sectionRow": `styles_sectionRow__rakkC`,
	"cardPreview": `styles_cardPreview__aS3-v`,
	"infoRow": `styles_infoRow__C5PFI`,
	"leftColumn": `styles_leftColumn__f7ARp`,
	"rightColumn": `styles_rightColumn__ZlUjV`,
	"previewInfo": `styles_previewInfo__x0fWp`,
	"scheduleIcon": `styles_scheduleIcon__K0Qxt`,
	"scheduleText": `styles_scheduleText__8eD3q`,
	"smartDescription": `styles_smartDescription__ZKu4p`,
	"descriptionLoading": `styles_descriptionLoading__GNWxs`,
	"loadingText": `styles_loadingText__PmO8y`,
	"fadeInOut": `styles_fadeInOut__kRGql`,
	"expandedDescription": `styles_expandedDescription__yboe0`,
	"oceanLogoWrapper": `styles_oceanLogoWrapper__ERtTx`,
	"oceanLogoSpinner": `styles_oceanLogoSpinner__+LFpY`,
	"oceanWave": `styles_oceanWave__l6tip`,
	"descriptionLabel": `styles_descriptionLabel__Jikp9`,
	"descriptionContent": `styles_descriptionContent__bCv0z`,
	"descriptionText": `styles_descriptionText__HzdCG`,
	"expandedContent": `styles_expandedContent__Ihd5Y`,
	"slideIn": `styles_slideIn__CgZ7g`,
	"courseDetails": `styles_courseDetails__S5IjV`,
	"detailItem": `styles_detailItem__y2Rlt`,
	"detailIcon": `styles_detailIcon__sX6NY`,
	"detailText": `styles_detailText__gBTfm`,
	"detailLabel": `styles_detailLabel__7pVcM`,
	"detailValue": `styles_detailValue__rTpHd`,
	"oceanLogo": `styles_oceanLogo__kpvhw`,
	"oceanLogoExpanded": `styles_oceanLogoExpanded__KOzjR`,
	"locationIcon": `styles_locationIcon__DRoUp`,
	"locationIconExpanded": `styles_locationIconExpanded__kE7wr`,
	"actionButtons": `styles_actionButtons__y-4aD`,
	"lastUpdated": `styles_lastUpdated__36R78`,
	"lastUpdatedLabel": `styles_lastUpdatedLabel__9Oiv5`,
	"lastUpdatedValue": `styles_lastUpdatedValue__TozRG`,
	"typingCursor": `styles_typingCursor__ZyKdS`,
	"blink": `styles_blink__eZp2X`,
	"uploadLoader": `styles_uploadLoader__2FyGk`,
	"dots": `styles_dots__tBDC6`,
	"dot": `styles_dot__C-Vww`,
	"moveUpFlow": `styles_moveUpFlow__UqFfR`,
	"arrow": `styles_arrow__HHH2P`,
	"moveUpDots": `styles_moveUpDots__kkhOQ`,
	"locationInputWrapper": `styles_locationInputWrapper__9U6M1`,
	"locationInput": `styles_locationInput__vi+Pn`,
	"tasksSection": `styles_tasksSection__1I4GL`,
	"tasksLabel": `styles_tasksLabel__mzGIw`,
	"tasksList": `styles_tasksList__UDwyb`,
	"taskItem": `styles_taskItem__cP44n`,
	"taskTitle": `styles_taskTitle__hbi3N`,
	"taskDueDate": `styles_taskDueDate__+GrT5`,
	"seeFullTaskListButton": `styles_seeFullTaskListButton__WN9JG`,
	"expandIcon": `styles_expandIcon__xTVT2`,
	"sectionChangeWarning": `styles_sectionChangeWarning__egFjO`,
	"fadeIn": `styles_fadeIn__lACu2`,
	"infoIcon": `styles_infoIcon__YKcs3`,
	"animatedBorderButton": `styles_animatedBorderButton__h7-Ne`,
	"borderTravelTop": `styles_borderTravelTop__X3mA4`,
	"borderTravelBottom": `styles_borderTravelBottom__RbWHl`,
	"exitTasksButton": `styles_exitTasksButton__jWyip`,
	"minimizeIcon": `styles_minimizeIcon__icuQb`,
	"noTasksMessage": `styles_noTasksMessage__P7jEt`,
	"tasksLoading": `styles_tasksLoading__iWQk7`,
	"tasksFocusedView": `styles_tasksFocusedView__tGH2a`,
	"tasksFocusedHeader": `styles_tasksFocusedHeader__ypuuo`,
	"tasksColumnsContainer": `styles_tasksColumnsContainer__GMhOa`,
	"tasksColumn": `styles_tasksColumn__KJdHW`,
	"columnTitle": `styles_columnTitle__+Bl4W`,
	"tasksCategorySection": `styles_tasksCategorySection__RM9DE`,
	"categoryTitle": `styles_categoryTitle__i8yp5`,
	"categoryDivider": `styles_categoryDivider__7O1Wv`,
	"tasksListFocused": `styles_tasksListFocused__tpmaX`,
	"taskItemFocused": `styles_taskItemFocused__vfO0R`,
	"taskItemContent": `styles_taskItemContent__YLwHT`,
	"taskToggleButton": `styles_taskToggleButton__7YzGn`,
	"checked": `styles_checked__iDLkq`,
	"checkIcon": `styles_checkIcon__gw4Mg`,
	"taskContent": `styles_taskContent__uVzXN`,
	"emptyTasksMessage": `styles_emptyTasksMessage__wMR4l`
};
export default ___CSS_LOADER_EXPORT___;
